import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

/** Avviso "Dati dimostrativi" (FR-044): segnala che i contenuti della pagina non sono reali. */
@Component({
  selector: 'bs-demo-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  host: { class: 'block' },
  template: `
    <aside
      aria-label="Dati dimostrativi"
      data-testid="demo-banner"
      class="flex items-start gap-3 rounded-2xl bg-bsite-100 px-4 py-3 text-sm text-bsite-900 ring-1 ring-inset ring-bsite-300 dark:bg-bsite-950 dark:text-bsite-100 dark:ring-bsite-800"
    >
      <bs-icon name="info" [size]="20" />
      <p>
        <strong class="font-semibold">Dati dimostrativi.</strong>
        Cantieri e contenuti di questa pagina sono esempi e non corrispondono a lavori reali.
      </p>
    </aside>
  `,
})
export class DemoBannerComponent {}
